import { TrailDrawer } from "./TrailDrawer.js";
export async function loadTrailEffect(engine, refresh = true) {
    await engine.addEffect("trail", new TrailDrawer(), refresh);
}
